import angular from 'angular';

import authApiFactory from './auth-api.factory';
import LmrcApiService from './lmrc-api.service';
import FakeLmrcApiService from './fake-lmrc-api.service';
const componentModule = angular
  .module('api', [])

  .factory('AuthApiFactory', authApiFactory.serviceFactory)
  .service('LmrcApiService', LmrcApiService)
  .service('FakeLmrcApiService', FakeLmrcApiService)

  .name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/components/api-service/index.js